const usersToimpersonatePLK = [
    'RBIKD015',
    'RBIGW001',
];


export default usersToimpersonatePLK;